
const newModel = () => {
    return {
        truongchuanQuocgiaHocsinhId: null,
        truongchuanQuocgiaId: null,
        tenTruongchuanQuocgia: null,
        idKy: null,
        tenKy: null,
        tongsoHocsinh: "0",
        tongsoHocsinhDadinhdanh: "0",
        hocsinhNu: "0",
        hocsinhDantocThieuso: "0",
        hocsinhKhuyettat: "0",
        hocsinh6den10Y: "0",
        hocsinh11den14Y: "0",
        hocsinh15den17Y: "0",
        ghiChu: null,
        enabled: null,
        dateCreated: null,
        userCreated: null,
        dateModified: null,
        userModified: null,
        isDeleted: null,
        userDeleted: null,
        dateDeleted: null,
        tenUserCreated: null,
        tenUserModified: null,
        tenUserDeleted: null

    }
}

const newFEModel = () => {
    return {
        truongchuanQuocgiaHocsinhId: null,
        truongchuanQuocgiaId: null,
        idKy: null,
        tongsoHocsinh: "0",
        tongsoHocsinhDadinhdanh: "0",
        hocsinhNu: "0",
        hocsinhDantocThieuso: "0",
        hocsinhKhuyettat: "0",
        hocsinh6den10Y: "0",
        hocsinh11den14Y: "0",
        hocsinh15den17Y: "0",
        ghiChu: null,
        enabled: true,
    }
}

const fromJson = (item) => {
    return {
        truongchuanQuocgiaHocsinhId: item.truongchuanQuocgiaHocsinhId,
        truongchuanQuocgiaId: item.truongchuanQuocgiaId,
        tenTruongchuanQuocgia: item.tenTruongchuanQuocgia,
        idKy: item.idKy,
        tenKy: item.tenKy,
        tongsoHocsinh: item.tongsoHocsinh,
        tongsoHocsinhDadinhdanh: item.tongsoHocsinhDadinhdanh,
        hocsinhNu: item.hocsinhNu,
        hocsinhDantocThieuso: item.hocsinhDantocThieuso,
        hocsinhKhuyettat: item.hocsinhKhuyettat,
        hocsinh6den10Y: item.hocsinh6den10Y,
        hocsinh11den14Y: item.hocsinh11den14Y,
        hocsinh15den17Y: item.hocsinh15den17Y,
        ghiChu: item.ghiChu,
        enabled: item.enabled,
        dateCreated: item.dateCreated,
        userCreated: item.userCreated,
        dateModified: item.dateModified,
        userModified: item.userModified,
        isDeleted: item.isDeleted,
        userDeleted: item.userDeleted,
        dateDeleted: item.dateDeleted,
        tenUserCreated: item.tenUserCreated,
        tenUserModified: item.tenUserModified,
        tenUserDeleted: item.tenUserDeleted,
    }
}

const parseModeltoFEModel = (item) => {
    return {
        truongchuanQuocgiaHocsinhId: item.truongchuanQuocgiaHocsinhId,
        truongchuanQuocgiaId: item.truongchuanQuocgiaId,
        idKy: item.idKy,
        tongsoHocsinh: item.tongsoHocsinh,
        tongsoHocsinhDadinhdanh: item.tongsoHocsinhDadinhdanh,
        hocsinhNu: item.hocsinhNu,
        hocsinhDantocThieuso: item.hocsinhDantocThieuso,
        hocsinhKhuyettat: item.hocsinhKhuyettat,
        hocsinh6den10Y: item.hocsinh6den10Y,
        hocsinh11den14Y: item.hocsinh11den14Y,
        hocsinh15den17Y: item.hocsinh15den17Y,
        ghiChu: item.ghiChu,
        enabled: item.enabled,
    }
}

const newPagingSearchModel = () => {
    return {
        pageNumber: null,
        pageSize: null,
        sort: null,
        truongchuanQuocgiaId: null,
        idKy: null,
        enabled: null,
    }

}

const newSearchModel = (item) => {
    return {
        truongchuanQuocgiaId: item.truongchuanQuocgiaId,
        idKy: item.idKy,
        enabled: item.enabled,
    }
}

const errors = () => {
    return {
        truongchuanQuocgiaHocsinhId: null,
        truongchuanQuocgiaId: null,
        idKy: null,
        tongsoHocsinh: null,
        tongsoHocsinhDadinhdanh: null,
        hocsinhNu: null,
        hocsinhDantocThieuso: null,
        hocsinhKhuyettat: null,
        hocsinh6den10Y: null,
        hocsinh11den14Y: null,
        hocsinh15den17Y: null,
        ghiChu: null,
        enabled: null,
    }
}

export const truongchuanQuocgiaHocsinhModel = {
    newModel,
    newFEModel,
    parseModeltoFEModel,
    fromJson,
    newPagingSearchModel,
    newSearchModel,
    errors,
}


